import { commonConstants } from "../actions/constants/commonConstants";
import { userConstants } from "../actions/constants/userConstants";
import { userService } from "../services/userService";
import { call, put } from "redux-saga/effects";


function* getRole(): any {
  try {
    const response = yield call(userService.getRole);
    if (response.success) {
      yield put({ type: userConstants.roleUserSuccess, payload: response.resultObject });
    } else {
      yield put({ type: userConstants.roleUserFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: userConstants.roleUserFailure, payload: error });
  }
}

function* createUser(action: any): any {
  try {
    const response = yield call(userService.createUser, action.payload);
    if (response.success) {
      yield put({ type: userConstants.userCreateSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.resultObject.message });
    } else {
      yield put({ type: userConstants.userCreateFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: userConstants.userCreateFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.errorMessage });
  }
}

function* listUsers(action: any): any {
  try {
    const response = yield call(userService.listUsers, action.payload);
    if (response.success) {
      yield put({ type: userConstants.userListSuccess, payload: response.resultObject });
    } else {
      yield put({ type: userConstants.userListFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: userConstants.userListFailure, payload: error });
  }
}

function* updateUser(action: any): any {
  try {
    const response = yield call(userService.updateUser, action.payload);
    if (response.success) {
      yield put({ type: userConstants.userUpdateSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || 'User updated successfully' });
      yield put({ type: userConstants.userListRequest });
    } else {
      yield put({ type: userConstants.userUpdateFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: userConstants.userUpdateFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || 'Failed to update user' });
  }
}

function* viewUser(action: any): any {
  try {
    const response = yield call(userService.viewUser, action.payload);
    if (response.success) {
      yield put({ type: userConstants.userViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: userConstants.userViewFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: userConstants.userViewFailure, payload: error });
  }
}


function* getProfile(action: any): any {
  try {
    const response = yield call(userService.userView, action.payload);
 
    if (response.success) {
      yield put({ type: userConstants.getProfileSuccess, payload: response.resultObject });
    } else {
      yield put({ type: userConstants.getProfileFailure, payload: response.message || response.errorMessage || 'Failed to fetch profile' });
    }
  } catch (error) {
    yield put({ type: userConstants.getProfileFailure, payload: error });
  }
}

function* updateProfile(action: any): any {
  try {
    const response = yield call(userService.userUpdate, action.payload);
    if (response.success) {
      yield put({ type: userConstants.updateProfileSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: userConstants.updateProfileFailure, payload: response.message || response.errorMessage  });
      yield put({ type: commonConstants.showMessageFailure, payload: response.message || response.errorMessage  });
    }
  } catch (error) {
    yield put({ type: userConstants.updateProfileFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || error?.message  });
  }
}

function* uploadProfileImage(action: any): any {
  try {
    const response = yield call(userService.profileImage, action.payload);
    if (response.success) {
      yield put({ type: userConstants.uploadProfileImageSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: userConstants.uploadProfileImageFailure, payload: response.message || response.errorMessage })
      yield put({ type: commonConstants.showMessageFailure, payload: response.message || response.errorMessage  });
    }
  } catch (error) {
    yield put({ type: userConstants.uploadProfileImageFailure, payload: error });
     yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || error?.message  });
  }
}


function* getTermsByType(action: any): any {
  try {
    const response = yield call(userService.getTermsByType, action.payload);
    if (response.success) {
      yield put({ type: userConstants.getTermsByTypeSuccess, payload: response.resultObject });
    } else {
      yield put({ type: userConstants.getTermsByTypeFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: userConstants.getTermsByTypeFailure, payload: error });
  }
}

export const userSaga = {
  getRole,
  listUsers,
  updateProfile,
  uploadProfileImage,
  createUser,
  getProfile,
  viewUser,
  updateUser,
  getTermsByType,
};



